import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  HostListener,
  Input,
} from '@angular/core';
import { Subject } from 'rxjs';

import { DropdownService } from '../../services/dropdown.service';

/**
 * Card image placement component
 */
@Component({
  selector: 'atx-dropdown-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dropdown-item.component.html',
  styleUrls: ['./dropdown-item.component.scss'],
  standalone: false,
})
export class DropdownItemComponent {
  @Input()
  public active = false;

  @Input()
  public disabled = false;

  @Input()
  public icon: string[];

  constructor(private dropdownService: DropdownService) {}

  @HostBinding('class.disabled')
  public get isDisabled() {
    return this.disabled && !this.active;
  }

  @HostBinding('class.active')
  public get isActive() {
    return this.active && !this.disabled;
  }

  @HostListener('click')
  public hostClick() {
    if (this.disabled) {
      return;
    }

    (this.dropdownService.descendantMenuItemClick$ as Subject<void>).next();
  }
}
